import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ChevronDown as Icon } from "react-feather";

import { EventsPeriod } from "../../api";
import { useTypedSelector } from "../../store/models/root.interface";

interface OptionItem {
  label: string;
  value: EventsPeriod;
}

export interface DateRangeProps {
  value: EventsPeriod;
  onChange: (value: EventsPeriod) => any;
}

const DateRange: React.FC<DateRangeProps> = (props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const period = useTypedSelector((state) => state.event.period);
  const hasFormValueChanged = (e: EventsPeriod, label: string) => {
    props.onChange(e);
  };

  const dateRangeArray: OptionItem[] = [
    {
      label: "Year to Date",
      value: "yearToDate",
    },
    {
      label: "Previous Month",
      value: "prevMonth",
    },
    {
      label: "Previous Quarter",
      value: "prevQuarter",
    },
    {
      label: "Quarter",
      value: "thisQuarter",
    },
    {
      label: "12 Months",
      value: "rollingYear",
    },
  ];
  const dateRangeLabel = dateRangeArray.filter((f) => period === f.value);

  return (
    <div className="d-flex align-items-center mx-3 date-range">
      <Dropdown color="primary" isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle size="sm" color="primary" className="d-flex align-items-center">
          <span className="mr-1">{dateRangeLabel[0].label}</span>
          <Icon size={14} />
        </DropdownToggle>
        <DropdownMenu container="body">
          {dateRangeArray.map((d, i) => {
            return (
              <DropdownItem
                key={i}
                active={period == d.value}
                onClick={() => hasFormValueChanged(d.value, d.label)}
              >
                {d.label}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default DateRange;
